import { Button } from '@slal/ui/buttons';
import { Modal, ModalBody, ModalFooter, ModalProps } from '@slal/ui/modal';
import { Article, Heading, P } from '@slal/ui/typography';
import { ComponentPropsWithoutRef } from 'react';
import {
    RatingBadge,
    StyledHeadingRoundel,
    StyledVolatilityRating,
    StyledVolatilityRatingHeadings,
    StyledVolatilityRatings,
} from './styles';
import { FundHelpModalProps } from './types';

export const VolatilityExplainedModal = ({ onClose, ...props }: ModalProps) => {
    return (
        <Modal onClose={onClose} title="Volatility rating" {...props}>
            <ModalBody>
                <Article>
                    <P>
                        The volatility rating of a fund indicates how much the fund price might move compared to other
                        funds. The higher the volatility rating (with 0 being the lowest and 7 being the highest), the
                        less stable the fund price is likely to be. Volatility ratings are one way to help you decide
                        how much risk you're comfortable taking with your investments.
                    </P>
                    <P>We regularly review volatility ratings, and these may change.</P>
                </Article>
            </ModalBody>

            <ModalFooter>
                <Button variant="solid" color="secondary" onClick={onClose}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export const VolatilityRatings = ({
    handleOpenVolatilityExplainedModal,
    ...otherProps
}: Partial<FundHelpModalProps> & ComponentPropsWithoutRef<'aside'>) => {
    const ratings = Array.from(Array(8).keys());
    const titleId = 'volatility-rating-title';
    const title = 'Volatility rating';
    return (
        <StyledVolatilityRating aria-labelledby={titleId} {...otherProps}>
            <Heading id={titleId} level={3} aria-label={title}>
                {title}{' '}
                <StyledHeadingRoundel
                    role="button"
                    onClick={handleOpenVolatilityExplainedModal}
                    aria-label="More information about volatility ratings"
                >
                    ?
                </StyledHeadingRoundel>
            </Heading>
            <StyledVolatilityRatingHeadings>
                <Heading level={5}>Lowest risk</Heading>
                <Heading level={5}>Highest risk</Heading>
            </StyledVolatilityRatingHeadings>
            <StyledVolatilityRatings role="list" aria-label="Ratings">
                {ratings.map(index => (
                    <RatingBadge key={index} role="listitem" index={index}>
                        {index}
                    </RatingBadge>
                ))}
            </StyledVolatilityRatings>
        </StyledVolatilityRating>
    );
};
